<template>

  <li>
       <i :class="icon"> </i>
       <slot></slot>
  </li>

</template>

<script>
export default {
 props:{
    icon: String
 }
}
</script>

<style scoped>

li{
   margin: 12px 8px;
   cursor: pointer;
   white-space: nowrap;
}
li:hover{

}
</style>